module.exports = __webpack_public_path__ + "img/logo-xiaomi.3bcaeacf.png";